<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <v-row>
                <v-col cols="4" md="4">
                    Naam
                </v-col>

                <v-col cols="8" md="4">
                    : {{GetUserName()}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" md="4">
                    Email
                </v-col>

                <v-col cols="8" md="4">
                    : {{formModel.clientEmail}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" md="4">
                    Datum afspraak
                </v-col>

                <v-col cols="8" md="4">
                    : {{formModel.appointmentMoment}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" md="4">
                    Type afspraak
                </v-col>

                <v-col cols="8" md="4">
                    : {{formModel.appointmentName}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" md="4">
                    Locatie
                </v-col>

                <v-col cols="8" md="4">
                    : {{formModel.locatieName}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" md="4">
                    Therapeut
                </v-col>

                <v-col cols="8" md="4">
                    : {{formModel.therapeutName}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-checkbox v-model="formModel.dataPermission"
                                :rules="[(v) => !!v || 'U moet akkoord gaan om door te gaan!']"
                                label="Ik heb de bovenstaande gegevens gecontroleerd*"
                                required></v-checkbox>
                </v-col>
            </v-row>
            <v-row> </v-row>
        </v-container>
    </v-form>
</template>

<style scoped>
    .container--fluid {
        word-break:break-word;
    }
</style>

<script>
    /* eslint-disable */
    import { mapState, mapActions } from "vuex";

    export default {
        props: {
            formModel: Object,
            resetData: Boolean,
            selected: Boolean,
        },
        data: () => ({
            valid: false,
        }),
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
            formValid: function () {
                return this.valid;
            },
        },
        methods: {
            ...mapActions({
                clearAlert: "alert/clear",
                showAlert: "alert/error",
                selectComp: "appBar/selectComp",
                updateFormModel: "appBar/updateFormModel",
            }),
            GetUserName() {
                let name = this.formModel.clientFirstName + " ";

                if (this.formModel.clientPrefixName != null) {
                    name = name + this.formModel.clientPrefixName + " ";
                }
                return (name + this.formModel.clientLastName);
            },
        },
        watch: {
            formValid: function (value) {
                this.updateFormModel({
                    formModel: {
                        id: 5,
                        title: "",
                        selected: true,
                    },
                });
            },
        },
    }
</script>